export default function customerDataSelector(func) {
  return func((state) => state.customerReducer);
}
